import { useCommonModal } from 'hooks/useCommonModal';
import { Department } from 'models/admin/Department';
import { useRef } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { GPopupTitle } from 'components/layouts/GLayoutBox';
import { DialogTitleItem } from 'components/layouts/GModalPopup';
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { GButton } from 'components/atom/button';
import Save from 'components/asset/images/Confirm.svg';
import { GbasicTable, GbasicTableWrap } from 'components/tables/GTable';
import { GLabelAtom } from 'components/atom/label';
import InputField from 'components/atom/input';
import { AlignBox } from 'components/organism/AlignBox';
import ModalLayout from 'components/layouts/ModalLayout';

type DepartmentModalProps = {
  open: boolean;
  singleSelect?: boolean;
  close: () => void;
  save: () => void;
};

const FindPassword = (props: DepartmentModalProps) => {
  const { t } = useTranslation();
  const gridRef = useRef<AgGridReact<Department>>(null);
  const { openCommonModal } = useCommonModal();

  const handleClose = () => {
    props.close();
  };

  const handleOnSave = () => {
    const selectedRows = gridRef.current?.api.getSelectedRows() || [];
    if (selectedRows.length === 0) {
      openCommonModal({
        modalType: 'alert',
        content: t(
          'department-choice-popup.alert.한 부서 이상 선택해야 합니다.',
          '__선택된 행이 없습니다.'
        ),
      });
      return;
    }
    props.close();
  };

  return (
    <ModalLayout open={props.open} onClose={handleClose} mMinWidth={400} mMaxWidth={400}>
      <DialogTitleItem id="customized-dialog-title" onClose={handleClose}>
        <GPopupTitle title2="비밀번호 찾기" />
      </DialogTitleItem>
      <DialogContent className="popupContent">
        <GbasicTableWrap isBottomMgn={false}>
          <GbasicTable>
            <colgroup>
              <col style={{ width: '120px' }} />
              <col style={{ width: 'auto' }} />
            </colgroup>
            <tbody>
              <tr>
                <th>
                  <GLabelAtom align="left">Vendor ID</GLabelAtom>
                </th>
                <td>
                  <AlignBox>
                    <InputField
                      status="default"
                      align="left"
                      placeholder="Vendor ID를 입력하세요"
                      width="168px"
                    />
                    <GButton
                      txt="확인"
                      sizes="medium"
                      btnstyled="outline"
                      btnColor="normal"
                      hasImg={false}
                      hasTxt={true}
                    ></GButton>
                  </AlignBox>
                </td>
              </tr>
              <tr>
                <th>
                  <GLabelAtom align="left">신규 패스워드</GLabelAtom>
                </th>
                <td>
                  <InputField
                    status="default"
                    align="left"
                    placeholder="Password를 입력하세요"
                    width="100%"
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <GLabelAtom align="left">패스워드 확인</GLabelAtom>
                </th>
                <td>
                  <InputField
                    status="default"
                    align="left"
                    placeholder="Password를 다시 입력하세요"
                    width="100%"
                  />
                </td>
              </tr>
            </tbody>
          </GbasicTable>
        </GbasicTableWrap>
      </DialogContent>
      <DialogActions className="popupBottom">
        <GButton
          txt="저장"
          sizes="medium"
          onClick={handleOnSave}
          chkImg={Save}
          btnstyled="contained"
          btnColor="primary"
          hasImg={true}
          hasTxt={true}
        />
      </DialogActions>
    </ModalLayout>
  );
};

export default FindPassword;
